/*
 *
 * GeoSearch actions
 *
 */

import {
  GEO_SEARCH,
  GEO_SEARCH_CLEAR,
  GEO_SEARCH_FOUND,
  GEO_SELECT,
} from './constants';

export function geoSearch(search) {
  return {
    type: GEO_SEARCH,
    search,
  };
}

export function geoSelect(item) {
  return {
    type: GEO_SELECT,
    item,
  };
}

export function geoSearchClear() {
  return {
    type: GEO_SEARCH_CLEAR,
  };
}

export function geoSearchFound(results) {
  return {
    type: GEO_SEARCH_FOUND,
    results,
  };
}
